import React from 'react';
import { Text } from '@radix-ui/themes';

const Select = ({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = 'Select an option',
  error,
  required = false,
  disabled = false,
  className = '',
}) => {
  return (
    <div className={`w-full ${className}`}>
      {label && (
        <Text
          as="label"
          htmlFor={name}
          size="2"
          weight="medium"
          style={{ display: 'block', marginBottom: '4px', color: '#1f1f1f', textAlign: 'left' }}
        >
          {label}
          {required && <span style={{ color: '#e5484d', marginLeft: '3px' }}>*</span>}
        </Text>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        style={{
          width: '100%',
          padding: '10px 12px',
          borderRadius: '6px',
          border: error ? '1px solid #e5484d' : '1px solid var(--gray-6)',
          backgroundColor: 'transparent',
          color: '#1f1f1f',
          fontSize: '14px',
          outline: 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = '#f05a35';
          e.target.style.boxShadow = '0 0 0 2px rgba(255,120,0,0.25)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error ? '#e5484d' : 'var(--gray-6)';
          e.target.style.boxShadow = 'none';
        }}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <Text size="1" style={{ color: '#e5484d', marginTop: '4px', display: 'block' }}>
          {error}
        </Text>
      )}
    </div>
  );
};

export default Select;